import Phaser from "phaser";
import { COLORS, TEXT_STYLES } from "../constants";

export class Panel extends Phaser.GameObjects.Container {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    width: number,
    height: number,
    title?: string
  ) {
    super(scene, x, y);

    const background = scene.add.rectangle(0, 0, width, height, COLORS.panelFill);
    background.setOrigin(0, 0);
    background.setStrokeStyle(2, COLORS.panelStroke);

    this.add(background);

    if (title) {
      const titleText = scene.add.text(width / 2, 8, title, TEXT_STYLES.subtitle).setOrigin(0.5, 0);
      this.add(titleText);
    }

    this.setSize(width, height);
    scene.add.existing(this);
  }
}
